import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import type { KollabCommentStreamProps, KollabCommentStreamAPI } from './types';

const DEFAULT_CUT_NOTES_URL = 'https://www.digitalrebellion.com/cutnotes';

/**
 * Renders the static info box that comment-stream files use in place of a
 * media viewer. A comment stream has a timecode timeline but no file content,
 * so the body of the player area just explains where comments come from.
 *
 * Mirrors the markup that previously lived inline at player.php:996-999.
 */
const KollabCommentStream = forwardRef<KollabCommentStreamAPI, KollabCommentStreamProps>(
  function KollabCommentStream(props, ref) {
    const containerRef = useRef<HTMLDivElement>(null);
    const cutNotesUrl = props.cutNotesUrl || DEFAULT_CUT_NOTES_URL;

    useImperativeHandle(ref, () => ({
      getContainerElement: () => containerRef.current,
    }), []);

    return (
      <div
        ref={containerRef}
        className="pageseccolor kollab-comment-stream-info"
        style={{
          marginTop: '1em',
          padding: 10,
          fontSize: 15,
          border: 'thin solid #ccc',
        }}
      >
        Comment streams allow you to add notes to Kollaborate without needing to upload a file. This is useful for sharing <a href={cutNotesUrl}>Cut Notes</a> comments from an external sync source such as Pro Tools.
        <p>You can only view and edit comments from this page. New comments must be added from <a href={cutNotesUrl}>Cut Notes</a>.</p>
      </div>
    );
  },
);

export default KollabCommentStream;
